import { Link } from 'react-router-dom';
import { faqItems } from '@/mocks/faq';
import { usePageMeta, useJsonLd } from '@/hooks/usePageMeta';

export default function Faq() {
  usePageMeta(
    {
      title: '常见问题 FAQ - 可信度、匿名保护与勘误说明 | 51爆料',
      desc: '51爆料常见问题解答：内容如何分级核实、投稿如何保证匿名、涉及隐私与名誉如何投诉勘误、平台立场与合作方式。',
    },
    '/faq'
  );
  useJsonLd('ld-faq', {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  });

  return (
    <div className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* 面包屑 */}
        <nav aria-label="面包屑" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
          <Link to="/" className="flex items-center gap-1 hover:text-primary-600">
            <i className="ri-home-4-line" aria-hidden="true"></i>首页
          </Link>
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          <span className="text-foreground-400">常见问题</span>
        </nav>

        {/* 标题 */}
        <div className="mt-6 grid gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="sticky top-32">
              <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
                <i className="ri-question-answer-line" aria-hidden="true"></i>
                FAQ
              </p>
              <h1 className="mt-2 font-display text-3xl font-black text-foreground-950 md:text-4xl">
                常见问题解答
              </h1>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                我们把读者最关心的信任问题放在最前面。若仍有疑问，欢迎直接联系我们。
              </p>
              <div className="mt-6 flex flex-col gap-2">
                {faqItems.map((f, i) => (
                  <a
                    key={i}
                    href={`#q${i + 1}`}
                    className="line-clamp-1 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
                  >
                    <span className="mr-2 font-medium text-primary-600">Q{i + 1}</span>
                    {f.q}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* 正文 */}
          <div className="lg:col-span-8">
            <div className="flex flex-col gap-5">
              {faqItems.map((f, i) => (
                <article
                  key={i}
                  id={`q${i + 1}`}
                  className="scroll-mt-28 rounded-lg border border-background-200 bg-background-100/50 p-6 md:p-7"
                >
                  <h2 className="flex items-start gap-3 font-display text-base font-bold leading-7 text-foreground-950 md:text-lg">
                    <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-accent-500 text-xs font-bold text-background-50">
                      {i + 1}
                    </span>
                    {f.q}
                  </h2>
                  <div className="mt-4 border-l-2 border-background-300 pl-5">
                    <p className="text-sm leading-8 text-foreground-700 md:text-[15px]">{f.a}</p>
                  </div>
                </article>
              ))}
            </div>

            {/* 底部引导 */}
            <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-lg bg-primary-600 p-6 text-background-50 sm:flex-row">
              <div>
                <h3 className="flex items-center gap-2 font-display text-lg font-bold">
                  <i className="ri-question-line text-accent-300" aria-hidden="true"></i>
                  还没找到你要的答案？
                </h3>
                <p className="mt-1 text-sm text-primary-100">关于爆料、勘误与合作，编辑会逐一回复每一封来信。</p>
              </div>
              <Link
                to="/about#contact"
                className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 hover:bg-accent-400"
              >
                <i className="ri-mail-send-line" aria-hidden="true"></i>
                联系编辑部
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}